import React, { useState } from 'react';
import classNames from 'classnames';
import { v4 } from 'uuid';
import CheckmarkIcon from '../../IconsDeprecated/CheckmarkIcon.js';
import { sizeOptions } from '../../../../helpers/enums/themes/sizeOptions.js';
import styles from './Checkbox.scss.js';

/**
 *
 * @param props.className Will apply the specified clasNames to the root label that wraps the checkbox
 */
const Checkbox = _ref => {
  let {
    checked,
    value,
    label,
    onChange,
    disabled,
    name,
    className,
    size = sizeOptions.medium,
    shouldStopPropagation,
    hasError = false
  } = _ref;
  const handleChange = () => {
    onChange({
      value: value || '',
      checked: !checked
    });
  };

  // On certain cases when including the checkbox as a child of another div or element with
  // an onClick handler we may need to stop propagation so the checkbox doesn't trigger the parent
  // element onClick handler when changing the checkbox
  const handleClick = event => {
    if (shouldStopPropagation) {
      event.stopPropagation();
    }
    if (!disabled) {
      onChange({
        value: value || '',
        checked: !checked
      });
    }
  };
  const iconWidth = {
    [sizeOptions.smallest]: 9,
    [sizeOptions.small]: 9,
    [sizeOptions.medium]: 16,
    [sizeOptions.big]: 24
  };
  const iconHeight = {
    [sizeOptions.smallest]: 13,
    [sizeOptions.small]: 13,
    [sizeOptions.medium]: 15,
    [sizeOptions.big]: 19
  };

  // Change this to useID in React 18
  // id is necessary for matching the label with its corresponding input
  // useful for when you have multiple checkboxes on the same view
  // failing to add id might cause onClick issues between different checkboxes
  const [id] = useState(() => `checkboxInput-${v4()}`);
  return /*#__PURE__*/React.createElement("label", {
    className: classNames(styles.container, className),
    htmlFor: id
  }, /*#__PURE__*/React.createElement("input", {
    id: id,
    type: "checkbox",
    name: name,
    value: value,
    checked: checked,
    onChange: handleChange,
    className: styles['input-checkbox'],
    disabled: disabled
  }), /*#__PURE__*/React.createElement("button", {
    role: "checkbox",
    type: "button",
    "aria-checked": checked,
    onClick: handleClick,
    className: classNames(styles.checkbox, {
      [styles[`checkbox--${size}`]]: true,
      [styles[`checkbox--error`]]: hasError && !checked && !disabled
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.checkbox__icon
  }, /*#__PURE__*/React.createElement(CheckmarkIcon, {
    height: iconHeight[size],
    width: iconWidth[size]
  }))), label);
};
var Checkbox$1 = Checkbox;

export { Checkbox$1 as default };
//# sourceMappingURL=Checkbox.js.map
